var React = require('react');

function CloseMenu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs6","key":0},React.createElement("style",{"id":"style8"},"\n            .close-line {fill:none;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px;}\n        ")),React.createElement("line",{"x1":"5.0536981","x2":"27.081896","y1":"5.0536981","y2":"27.081896","className":"close-line","id":"line10","style":{"fill":"none","stroke":"currentColor","strokeWidth":"4.45014095px","strokeLinecap":"square","strokeMiterlimit":"10"},"key":1}),React.createElement("line",{"x1":"27.081896","x2":"5.0536981","y1":"5.0536981","y2":"27.081896","className":"close-line","id":"line12","style":{"fill":"none","stroke":"currentColor","strokeWidth":"4.45014095px","strokeLinecap":"square","strokeMiterlimit":"10"},"key":2})]);
}

CloseMenu.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = CloseMenu;

CloseMenu.default = CloseMenu;
